import { EWorkerInformationSection } from "../shareable-links";
import { ESSNVerificationStatus } from "./ESSNVerificationStatus";

export const paycardSSNVerificationStatusToShareableLinkSection = {
  [ESSNVerificationStatus.id_verification_required]:
    EWorkerInformationSection.PAYCARD_SSN_ID_VERIFICATION,
  [ESSNVerificationStatus.social_security_card_required]:
    EWorkerInformationSection.PAYCARD_SSN_SSC_VERIFICATION,
} as const;
